import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import vuetify from './plugins/vuetify'
import './assets/css/font.css'
import './assets/css/styles.scss'
import CKEditor from '@ckeditor/ckeditor5-vue'
import moment from 'vue-moment'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSweetalert2);
// CommonJS
Vue.use( CKEditor );
Vue.use( moment );

Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
